export default "https://cdn-static.gokick.com/assets/b944ecdade3ab4b24738bd1fcec1eea00d00fb75/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";